var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5667 2C9.94665 2 7.81665 4.13 7.81665 6.75C7.81665 9.32 9.82665 11.4 12.4467 11.49C12.5267 11.48 12.6067 11.48 12.6667 11.49C12.6867 11.49 12.6967 11.49 12.7167 11.49C12.7267 11.49 12.7267 11.49 12.7367 11.49C15.2967 11.4 17.3067 9.32 17.3167 6.75C17.3167 4.13 15.1867 2 12.5667 2Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.6466 14.1528C14.8566 12.2928 10.3066 12.2928 7.49661 14.1528C6.22661 15.0028 5.52661 16.1528 5.52661 17.3828C5.52661 18.6128 6.22661 19.7528 7.48661 20.5928C8.88661 21.5328 10.7266 22.0028 12.5666 22.0028C14.4066 22.0028 16.2466 21.5328 17.6466 20.5928C18.9066 19.7428 19.6066 18.6028 19.6066 17.3628C19.5966 16.1328 18.9066 14.9928 17.6466 14.1528Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5667 16.6328H13.3167V15.3828C13.3167 14.9728 12.9767 14.6328 12.5667 14.6328C12.1567 14.6328 11.8167 14.9728 11.8167 15.3828V16.6328H10.5667C10.1567 16.6328 9.81665 16.9728 9.81665 17.3828C9.81665 17.7928 10.1567 18.1328 10.5667 18.1328H11.8167V19.3828C11.8167 19.7928 12.1567 20.1328 12.5667 20.1328C12.9767 20.1328 13.3167 19.7928 13.3167 19.3828V18.1328H14.5667C14.9767 18.1328 15.3167 17.7928 15.3167 17.3828C15.3167 16.9728 14.9767 16.6328 14.5667 16.6328Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon02);
export default __webpack_public_path__ + "static/media/menu-icon-02.a6e2ad9c98c78559d8290ff0ce17c066.svg";
export { ForwardRef as ReactComponent };